import {
  Avatar,
  Box,
  Button,
  Grid2 as Grid,
  IconButton,
  Typography,
} from "@mui/material";
import {
  handleDeleteComment,
  updateComment,
} from "../../redux/guest-slices/common.slice";
import { refresher } from "../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import { getDiffTime } from "../../utils/helper";
import { useToast } from "../../hooks/useToast";
import Icons from "../../assets/js/Icons";
import InputField1 from "./InputField1";
import { useRef } from "react";

function CommentA({ commnetType, comment, reply, setReply, hideAuthor }) {
  const toast = useToast();
  const dispatch = useDispatch();
  const commentRef = useRef(null);
  const { loadings } = useSelector((state) => state.otherSlice);
  const { member, specialist } = useSelector((state) => state.authSlice);

  const handleReplyView = () => {
    setReply({ id: comment?._id, view: true });
  };

  const handleUpdate = async () => {
    let formData;
    formData = {
      commentId: commnetType === "commentEdit" ? null : comment?._id,
      description: commentRef.current?.value,
    };
    if (!formData?.description || formData?.description?.trim() === "") {
      return toast.error("Please enter comment!");
    }

    try {
      await dispatch(updateComment({ id: comment?._id, formData })).unwrap();

      setReply({ id: null, view: false });

      setTimeout(() => {
        dispatch(refresher());
      }, 1000);

      toast.success("Comment updated successfully!");
    } catch (error) {
      console.error("Update comment error:", error);
      toast.error("Failed to update comment");
    }
  };

  const handleDelete = async () => {
    try {
      await dispatch(handleDeleteComment(comment?._id)).unwrap();

      setTimeout(() => {
        dispatch(refresher());
      }, 1000);

      toast.success("Comment deleted successfully!");
    } catch (error) {
      console.error("Delete comment error:", error);
      toast.error("Failed to delete comment");
    }
  };

  return (
    <Grid key={comment?._id} container>
      <Grid size={{ xs: 12, md: "grow" }}>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
          }}
        >
          {!hideAuthor && (
            <Avatar
              sx={{ width: 35, height: 35 }}
              src={specialist?.image || member?.image}
            />
          )}
          <Box>
            {!hideAuthor && (
              <Typography
                mb={0.5}
                lineHeight="1"
                variant="body1"
                fontWeight="500"
                color="other.color1"
                textTransform="capitalize"
              >
                {specialist?.fullName || member?.fullName}
              </Typography>
            )}
            <Typography fontSize={12} lineHeight="1" color="other.color2">
              {getDiffTime(comment?.createdAt)} ago
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, md: "auto" }}>
        <IconButton
          size="small"
          onClick={handleReplyView}
          disabled={loadings?.update} // Disable during update
        >
          <Icons.EditSolid />
        </IconButton>
        <IconButton
          size="small"
          onClick={handleDelete}
          disabled={loadings?.update} // Disable during update
        >
          <Icons.DeleteSolid />
        </IconButton>
      </Grid>
      <Grid size={12} sx={{ mt: 1 }}>
        {reply?.view && reply?.id === comment?._id ? (
          <>
            <InputField1
              name="comment"
              type="textarea"
              inputRef={commentRef}
              defaultValue={comment?.description}
              placeholder="Write your comment here.."
            />
            <Button
              color="secondary"
              variant="contained"
              onClick={handleUpdate}
              disabled={loadings?.update}
              sx={{ width: "100%", mt: 1 }}
            >
              {loadings?.update ? "Updating..." : "Update Comment"}
            </Button>
          </>
        ) : (
          <Typography>{comment?.description}</Typography>
        )}
      </Grid>
    </Grid>
  );
}

export default CommentA;
